import { AddIntegrationSettings } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationSettings';
import { useAppSelector } from 'src/store';
import type { IntegrationSubmitHandler } from 'src/components/Integrations/integrationFormTypes';

interface IntegrationModalStep2Props {
  onSubmit: IntegrationSubmitHandler;
  onBackButton: () => void;
  close?: (isFinal?: boolean) => void;
}

export const IntegrationModalStep2 = ({
  onSubmit,
  onBackButton,
  close,
}: IntegrationModalStep2Props) => {
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const isLastStep = selectedIntegration?.setupSteps === 2;

  return (
    <AddIntegrationSettings
      defaultBtnStyle
      isLastStep={isLastStep}
      onSubmit={onSubmit}
      onBackButton={onBackButton}
      close={close}
    />
  );
};
